import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'

export default class extends BaseComponent {

	constructor(props) {

    super(props)
    this.state = { cookies: true }
    this.cookie = this.readCookie('cookie-info');
    this._bind('createCookie', 'readCookie', 'acceptCookies')
  }

  createCookie(name,value,days) {
      if (days) {
          var date = new Date();
          date.setTime(date.getTime()+(days*24*60*60*1000));
          var expires = "; expires="+date.toGMTString();
      }
      else var expires = "";
      document.cookie = name+"="+value+expires+"; path=/";
  }

  readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

  acceptCookies() {
    this.setState({ cookies: false })
    this.createCookie('cookie-info', true, 30);
  }

  render() {

    var cookies = "";
    if(!this.cookie) {

      cookies = (<div className={ this.state.cookies ? "cookies show" : "cookies" }><div className="close" onClick={ this.acceptCookies }></div>Ta strona używa plików cookies (ciasteczek), dzięki którym nasz serwis może działać lepiej. Korzystając ze strony wyrażasz zgodę na użycie plików cookie.<br/> <NavLink to="/polityka-prywatnosci">Dowiedz się więcej >.</NavLink></div>)
    }

    return (
      <footer>
        <div className="footer-nav container">
        	<NavLink to={ this.props.lang === "pl" ? "/polityka-prywatnosci" : "/en/privacy-policy" }>Polityka prywatności i danych osobowych</NavLink>
        </div>
        { cookies }
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Footer.js